/* eslint-disable react/forbid-prop-types */

import React, { useState } from 'react';
import { MdPlayArrow } from 'react-icons/md';

import PropTypes from 'prop-types';

import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
} from '@material-ui/core';

import CustomDialogTitle from '~/components/CustomDialogTitle';
import LocaleMessage from '~/components/LocaleMessage';

import api from '~/services/pluginbot-api';

import { JsonBlock, DetailField } from '../style';

function formatJson(value) {
    if (value == null) return '---';

    try {
        return JSON.stringify(value, null, 2);
    } catch {
        return String(value);
    }
}

function getStatusLabel(receivedData) {
    if (!receivedData) return 'ERROR';

    if (receivedData.reason === 'request_failed') return 'ERROR';

    const code = receivedData.statusCode;

    if (code >= 200 && code < 300) return String(code);

    return code ? String(code) : 'ERROR';
}

export default function AppKeyCallbackDetails({
    item,

    onClose,

    onReplayed,

    requestError,

    dark_mode,
}) {
    const [detail, setDetail] = useState(item);

    const [isReplaying, setIsReplaying] = useState(false);

    if (!item) return null;

    async function handleReplay() {
        setIsReplaying(true);

        await api

            .post(`reports/appkey_callbacks/${detail.id}/replay`)

            .then(response => {
                const { received_data: receivedData } = response.data;

                const status_label = getStatusLabel(receivedData);

                const updated = {
                    ...detail,

                    received_data: receivedData,

                    status_label,
                };

                setDetail(updated);

                if (onReplayed) onReplayed(updated);
            })

            .catch(error => requestError(error))

            .finally(() => setIsReplaying(false));
    }

    return (
        <Dialog open onClose={onClose} maxWidth="md" fullWidth>
            <CustomDialogTitle
                title={
                    <LocaleMessage msg="page.reports.appkey_callbacks.label.detail_title" />
                }
            />

            <DialogContent>
                <DetailField>
                    <strong>
                        <LocaleMessage msg="table.headers.date" />
                    </strong>

                    <span>{detail.created || '---'}</span>
                </DetailField>

                <DetailField>
                    <strong>API Key</strong>

                    <span>{detail.appkey || '---'}</span>
                </DetailField>

                <DetailField>
                    <strong>
                        <LocaleMessage msg="table.headers.application" />
                    </strong>

                    <span>{detail.application || '---'}</span>
                </DetailField>

                <DetailField>
                    <strong>
                        <LocaleMessage msg="page.reports.appkey_callbacks.label.callback_url" />
                    </strong>

                    <span>{detail.callback_url || '---'}</span>
                </DetailField>

                <DetailField>
                    <strong>
                        <LocaleMessage msg="page.reports.appkey_callbacks.label.callback_type" />
                    </strong>

                    <span>{detail.callback_type || '---'}</span>
                </DetailField>

                <DetailField>
                    <strong>
                        <LocaleMessage msg="page.reports.appkey_callbacks.label.status" />
                    </strong>

                    <span>{detail.status_label || '---'}</span>
                </DetailField>

                <DetailField column>
                    <strong>
                        <LocaleMessage msg="page.reports.appkey_callbacks.label.sent_data" />
                    </strong>

                    <JsonBlock dark={dark_mode}>
                        {formatJson(detail.sent_data)}
                    </JsonBlock>
                </DetailField>

                <DetailField column>
                    <strong>
                        <LocaleMessage msg="page.reports.appkey_callbacks.label.received_data" />
                    </strong>

                    <JsonBlock dark={dark_mode}>
                        {formatJson(detail.received_data)}
                    </JsonBlock>
                </DetailField>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleReplay}
                    color="primary"
                    variant="contained"
                    disabled={
                        isReplaying || !detail.callback_url || !detail.sent_data
                    }
                    startIcon={
                        isReplaying ? (
                            <CircularProgress size={18} color="inherit" />
                        ) : (
                            <MdPlayArrow />
                        )
                    }
                >
                    <LocaleMessage msg="page.reports.appkey_callbacks.button.replay" />
                </Button>

                <Button onClick={onClose} color="primary">
                    <LocaleMessage msg="button.close" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

AppKeyCallbackDetails.propTypes = {
    item: PropTypes.object.isRequired,

    onClose: PropTypes.func.isRequired,

    onReplayed: PropTypes.func,

    requestError: PropTypes.func.isRequired,

    dark_mode: PropTypes.bool,
};

AppKeyCallbackDetails.defaultProps = {
    onReplayed: null,

    dark_mode: false,
};
